import { render } from "./B2bFiltersInventoryReport.vue?vue&type=template&id=539243a9&scoped=true&lang=pug"
import script from "./B2bFiltersInventoryReport.vue?vue&type=script&lang=js"
export * from "./B2bFiltersInventoryReport.vue?vue&type=script&lang=js"

import "./B2bFiltersInventoryReport.vue?vue&type=style&index=0&id=539243a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539243a9"]])

export default __exports__